import { render, staticRenderFns } from "./storageEnclosure.vue?vue&type=template&id=de15b7b2&"
import script from "./storageEnclosure.vue?vue&type=script&lang=js&"
export * from "./storageEnclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports